// import Vue from 'vue'
// import Router from 'vue-router'
//
// Vue.use(Router)

export default
[
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: () => import('@/iview/home'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页'
        },
        component: () => import('@/iview/home')
      }
    ]
  },
  {
    path: '/hint',
    name: 'hint',
    meta: {
      title: '提示'
    },
    component: () => import('@/iview/hint/hint')
  }
]
